// This file was automatically generated from appshared.dialog.addDiscreteLabValues.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.addDiscreteLabValues');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.formContents = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appshared.dialog.addDiscreteLabValues.vendorField(opt_data, output);
  output.append('<div class="after-vendor-selected hidden">');
  el8.template.appshared.dialog.addDiscreteLabValues.panelField(null, output);
  output.append('<div class="after-panel-selected hidden">');
  el8.template.appshared.dialog.addDiscreteLabValues.testSection(null, output);
  output.append('</div></div><div class="lab-entry-result-section hidden"><div class="el8Spacer"></div>');
  el8.template.appshared.dialog.addDiscreteLabValues.testHeaders(null, output);
  el8.template.appshared.dialog.addDiscreteLabValues.labEntryList(null, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.chartDialog = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol class="el8SlidingPaneWrap ebs-list-unstyled"><li class="el8SlidingPaneItem el8OverflowAuto" style="width: 380px;"><div class="new-lab-entry-panel m10"><p class="el8Bold el8Spacer5 el8AppColor">Enter Lab Values</p><div class="el8Spacer el8OverflowAuto" style="min-height: 230px"><div id="panel-lab-values-content"></div><div class="el8AlignCenter ebs-text-center mt15 mb15"><a class="legacy-lab-entry-trigger el8DialogLink">Manually Enter Another Lab Value</a></div></div></div><form id="add-lab-values-chartdialog" class="legacy-lab-entry-panel el8DialogContainer" style="width:345px;"><p class="el8Bold el8Spacer5 el8AppColor"><a class="new-lab-entry-trigger el8DialogLink">&#8592; Return</a> Manually Enter Lab Values</p>');
  el8.template.appshared.dialog.addDiscreteLabValues.formContents(opt_data, output);
  output.append('</form></li><li class="el8SlidingPaneItem el8OverflowAuto chart-dialog-feed-container">');
  el8.template.appshared.dialog.addDiscreteLabValues.reportFeed(null, output);
  output.append('</li></ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.reportFeed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LabInputImageContainer chart-dialog-images"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.testHeaders = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8Bold el8Spacer5 pad5 el8AppColor">Lab Results To Be Saved</p><ol class="el8ResultsGrid ebs-list-unstyled"><li class="el8ResultsGridHeader el8FieldSectionOverflow ebs-clearfix"><div class="w43 fl ebs-pull-left">Test Name</div><div class="w20 fl ebs-pull-left">Value</div><div class="el8ResultsGridHeaderLast w35 fl ebs-pull-left">Reference Range</div></li></ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.panelField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8Bold el8Spacer5 pad5 el8AppColor">2. Type Lab Result</p><div class="el8TextareaWrap mb10"><textarea type="text" class="w100 ebs-form-control" name="panelName"></textarea></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.testSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldSectionOverflow mb10 ebs-row"><div class="el8TextareaWrapLessMargin w43 fl ebs-col-sm-4 padr2"><input type="text" class="w100 ebs-form-control" name="testName" /></div><div class="el8TextareaWrapLessMargin w8 fl ebs-col-sm-2 padh2"><input type="text" class="w100 ebs-form-control" name="testValue" /></div><div class="el8TextareaWrapLessMargin w8 fl ebs-col-sm-2 padh2"><input type="text" class="w100 ebs-form-control" name="refMin" /></div><div class="el8TextareaWrapLessMargin w8 fl ebs-col-sm-2 padh2"><input type="text" class="w100 ebs-form-control" name="refMax" /></div><div class="el8TextareaWrapLessMargin w12 fl ebs-col-sm-2 padl2"><input type="text" class="w100 ebs-form-control" name="units" /></div></div><div class="el8Spacer5"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" class="add-lab-value-trigger ebs-btn ebs-btn-default">Save Entry</button></li><li class="el8ButtonItem"><a class="clear-lab-form-trigger el8DialogLink ebs-btn ebs-btn-link">Clear Form</a></li></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.vendorField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8Bold el8Spacer5 pad5 el8AppColor">1. Select Lab Vendor</p><div class="el8Wrap mb20"><select name="vendorId" class="w100">');
  if (opt_data.vendorChoices) {
    output.append('<option value="-1">Select a vendor to continue...</option>');
    var vList7814 = opt_data.vendorChoices;
    var vListLen7814 = vList7814.length;
    for (var vIndex7814 = 0; vIndex7814 < vListLen7814; vIndex7814++) {
      var vData7814 = vList7814[vIndex7814];
      el8.template.appshared.dialog.addDiscreteLabValues.vendorOption({vendor: vData7814}, output);
    }
    output.append((! el8Globals.FEATURES.BiDiLabs) ? '<option value="">Create a new vendor...</option>' : '');
  }
  output.append('</select></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.vendorOption = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<option value="', soy.$$escapeHtml(opt_data.vendor.id), '">', soy.$$escapeHtml(opt_data.vendor.name), '</option>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.labEntryList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="lab-value-list el8Spacer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.labPanel = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol class="lab-panel el8ResultsGrid ebs-list-unstyled" _id=', soy.$$escapeHtml(opt_data.labtestcategory_id), '><li class="el8ResultsGridPanelName">', soy.$$escapeHtml(opt_data.panel_name), '</li></ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.labEntry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="lab-value-row el8ItemHover" _id="', soy.$$escapeHtml(opt_data.labtest_id), '"><div class="el8ItemButtonContainer"><button type="button" class="edit-lab-value-trigger el8ItemButton ebs-btn ebs-btn-default">Edit</button></div><a class="remove-lab-value-trigger el8RemoveItemButton"></a><div class="el8FieldSectionOverflow ebs-clearfix"><div class="w43 fl ebs-pull-left"><div class="el8LeftIndentExtraLarge">', soy.$$escapeHtml(opt_data.test_name), '</div></div><div class="el8AlignCenter w20 fl ebs-pull-left ebs-text-center">', soy.$$escapeHtml(opt_data.value), '</div><div class="el8AlignCenter w35 fl ebs-pull-left ebs-text-center">', (opt_data.ref_min) ? soy.$$escapeHtml(opt_data.ref_min) + ((opt_data.ref_max) ? ' - ' + soy.$$escapeHtml(opt_data.ref_max) : '') : (opt_data.ref_max) ? soy.$$escapeHtml(opt_data.ref_max) : '', (opt_data.units) ? ' ' + soy.$$escapeHtml(opt_data.units) : '', '</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.labPanelSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h4 id="add-panel-lab-value-', soy.$$escapeHtml(opt_data.labtestcategoryId), '-trigger" class="el8SectionHeader"><span id="add-panel-lab-value-', soy.$$escapeHtml(opt_data.labtestcategoryId), '-status" class="el8Elt"></span>', soy.$$escapeHtml(opt_data.description), '</h4><div id="add-panel-lab-value-', soy.$$escapeHtml(opt_data.labtestcategoryId), '-section" class="ebs-container-fluid">');
  var testList7868 = opt_data.tests;
  var testListLen7868 = testList7868.length;
  for (var testIndex7868 = 0; testIndex7868 < testListLen7868; testIndex7868++) {
    var testData7868 = testList7868[testIndex7868];
    el8.template.appshared.dialog.addDiscreteLabValues.simpleLabValueForm({labtestId: testData7868.labtest_id, name: testData7868.name, refMax: testData7868.ref_max, refMin: testData7868.ref_min, units: testData7868.units, oldCss: opt_data.oldCss, wider: opt_data.wider}, output);
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.addDiscreteLabValues.simpleLabValueForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ebs-row padb5"><div class="', (opt_data.oldCss) ? 'el8InlineBlock w50' : '', ' el8StandardFontSize padl20 padt3 padr0 ebs-text-left ', (opt_data.wider) ? 'ebs-col-xs-5' : 'ebs-col-xs-6', '">', soy.$$escapeHtml(opt_data.name), ':</div><div class="', (opt_data.oldCss) ? 'el8InlineBlock w20 el8AlignCenter ' : '', (opt_data.wider) ? 'ebs-col-xs-4' : 'ebs-col-xs-3', ' padr0"><div class="el8StandardFontSize el8TextareaWrap"><input type="text" spellcheck="false" autocomplete="off" maxlength="15" class="', (opt_data.oldCss) ? 'el8InlineBlock el8StandardFontSize w90 el8AlignCenter ' : '', 'ebs-text-center lab-value-field-entry ebs-form-control" data-labtest-id="', soy.$$escapeHtml(opt_data.labtestId), '" title="', (opt_data.refMin) ? soy.$$escapeHtml(opt_data.refMin) + ((opt_data.refMax) ? ' - ' + soy.$$escapeHtml(opt_data.refMax) : '') : (opt_data.refMax) ? soy.$$escapeHtml(opt_data.refMax) : '', (opt_data.units) ? ' ' + soy.$$escapeHtml(opt_data.units) : '', '" /></div></div><div class="', (opt_data.oldCss) ? 'el8InlineBlock' : '', ' el8StandardFontSize padl5 padt5 padr0 ', (opt_data.wider) ? 'ebs-col-xs-3' : 'ebs-col-xs-3', '">', (opt_data.units) ? soy.$$escapeHtml(opt_data.units) : '', '</div></div>');
  if (!opt_sb) return output.toString();
};
